/* =========================================================
   NEOLAB global.js
   - SPドロワーメニュー開閉
   - details アコーディオン補助（SP/PC切替・閉じるアニメ）
   - カート数量 ±
   - 汎用モーダルヘルパー window.NLModal
   Vanilla JS のみ / 外部依存なし
   ========================================================= */
(function () {
  'use strict';

  var SP_QUERY = window.matchMedia('(max-width: 749px)');

  function lockScroll(lock) {
    document.body.classList.toggle('nl-lock', !!lock);
  }

  /* ---------------------------------------------------------
     1. ドロワー（SPメニュー等）
     開くトリガ : [data-drawer-toggle]（aria-controls でドロワーidを指定）
     閉じるトリガ: [data-drawer-close]
     ドロワー本体: [data-drawer]
  --------------------------------------------------------- */
  function getDrawerFor(toggle) {
    var id = toggle.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setDrawerState(drawer, open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-drawer-toggle][aria-controls="' + drawer.id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    lockScroll(open || openModals.length > 0);
    if (open) {
      var focusable = drawer.querySelector('[data-drawer-close], a, button, input');
      if (focusable) focusable.focus({ preventScroll: true });
    }
  }

  function closeAllDrawers() {
    document.querySelectorAll('[data-drawer].is-open').forEach(function (d) {
      setDrawerState(d, false);
    });
  }

  /* ---------------------------------------------------------
     2. details アコーディオン補助
     - .nl-accordion : 閉じるときも滑らかに（高さアニメ）
     - [data-accordion-sp] : SPのみアコーディオン（PCでは常時 open）
  --------------------------------------------------------- */
  function animateClose(details) {
    var content = details.querySelector('.nl-accordion__content');
    if (!content || typeof content.animate !== 'function') {
      details.removeAttribute('open');
      return;
    }
    var anim = content.animate(
      [
        { height: content.offsetHeight + 'px', opacity: 1 },
        { height: '0px', opacity: 0 }
      ],
      { duration: 220, easing: 'ease' }
    );
    content.style.overflow = 'hidden';
    anim.onfinish = function () {
      content.style.overflow = '';
      details.removeAttribute('open');
    };
  }

  function syncResponsiveAccordions() {
    document.querySelectorAll('details[data-accordion-sp]').forEach(function (details) {
      if (SP_QUERY.matches) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });
  }

  /* ---------------------------------------------------------
     3. カート数量 ±
     対応マークアップ（どちらでも可）:
       a) [data-qty] 内の [data-qty-plus] / [data-qty-minus]
       b) .nl-qty / .quantity 内の button[name="plus"] / button[name="minus"]
     変更後 input に change イベントを発火する
  --------------------------------------------------------- */
  function stepQuantity(button, delta) {
    var wrapper = button.closest('[data-qty], .nl-qty, .quantity');
    if (!wrapper) return;
    var input = wrapper.querySelector('input[type="number"], input[name="quantity"], input[name*="updates"]');
    if (!input) return;

    var step = parseFloat(input.step) || 1;
    var min = input.min !== '' ? parseFloat(input.min) : 0;
    var max = input.max !== '' ? parseFloat(input.max) : Infinity;
    var value = parseFloat(input.value) || 0;
    var next = Math.min(max, Math.max(min, value + delta * step));

    if (next === value) return;
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------------------------------------------------------
     4. 汎用モーダル window.NLModal
     モーダル本体: [data-modal]（.nl-modal 推奨）
     開くトリガ  : [data-modal-open="#ModalId"]
     閉じるトリガ: [data-modal-close] / スクリム / Esc
  --------------------------------------------------------- */
  var openModals = [];
  var lastFocused = null;

  function resolveModal(target) {
    if (!target) return null;
    if (typeof target === 'string') return document.querySelector(target);
    if (target instanceof Element) return target;
    return null;
  }

  var NLModal = {
    open: function (target) {
      var modal = resolveModal(target);
      if (!modal || modal.classList.contains('is-open')) return modal;
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      openModals.push(modal);
      lockScroll(true);
      var focusable = modal.querySelector('[data-modal-close], button, a, input, select, textarea');
      if (focusable) focusable.focus({ preventScroll: true });
      modal.dispatchEvent(new CustomEvent('nl:modal:open', { bubbles: true }));
      return modal;
    },
    close: function (target) {
      var modal = resolveModal(target) || openModals[openModals.length - 1];
      if (!modal || !modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      openModals = openModals.filter(function (m) { return m !== modal; });
      if (openModals.length === 0) {
        lockScroll(document.querySelector('[data-drawer].is-open') !== null);
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        }
      }
      modal.dispatchEvent(new CustomEvent('nl:modal:close', { bubbles: true }));
    },
    closeAll: function () {
      openModals.slice().forEach(function (m) { NLModal.close(m); });
    }
  };

  window.NLModal = NLModal;

  /* ---------------------------------------------------------
     イベント委譲
  --------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var target = event.target;

    /* ドロワー開閉 */
    var drawerToggle = target.closest('[data-drawer-toggle]');
    if (drawerToggle) {
      event.preventDefault();
      var drawer = getDrawerFor(drawerToggle);
      if (drawer) setDrawerState(drawer, !drawer.classList.contains('is-open'));
      return;
    }

    var drawerClose = target.closest('[data-drawer-close]');
    if (drawerClose) {
      event.preventDefault();
      var closingDrawer = drawerClose.closest('[data-drawer]');
      if (closingDrawer) setDrawerState(closingDrawer, false);
      return;
    }

    /* モーダル開閉 */
    var modalOpener = target.closest('[data-modal-open]');
    if (modalOpener) {
      event.preventDefault();
      NLModal.open(modalOpener.getAttribute('data-modal-open'));
      return;
    }

    var modalCloser = target.closest('[data-modal-close]');
    if (modalCloser) {
      event.preventDefault();
      NLModal.close(modalCloser.closest('[data-modal]'));
      return;
    }

    /* スクリムのクリックで閉じる */
    if (target.classList && target.classList.contains('nl-modal__scrim')) {
      NLModal.close(target.closest('[data-modal]'));
      return;
    }

    /* 数量 ± */
    var plusBtn = target.closest('[data-qty-plus], .nl-qty button[name="plus"], .quantity button[name="plus"]');
    if (plusBtn) {
      event.preventDefault();
      stepQuantity(plusBtn, 1);
      return;
    }

    var minusBtn = target.closest('[data-qty-minus], .nl-qty button[name="minus"], .quantity button[name="minus"]');
    if (minusBtn) {
      event.preventDefault();
      stepQuantity(minusBtn, -1);
      return;
    }

    /* アコーディオン: 閉じアニメ */
    var summary = target.closest('.nl-accordion > summary');
    if (summary) {
      var details = summary.parentElement;
      if (details.hasAttribute('open')) {
        event.preventDefault();
        animateClose(details);
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (openModals.length > 0) {
      NLModal.close();
    } else {
      closeAllDrawers();
    }
  });

  /* SP/PC 切替時の同期 */
  if (typeof SP_QUERY.addEventListener === 'function') {
    SP_QUERY.addEventListener('change', function () {
      syncResponsiveAccordions();
      if (!SP_QUERY.matches) closeAllDrawers();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncResponsiveAccordions);
  } else {
    syncResponsiveAccordions();
  }
})();
